import { FormField } from "@prosolve/common-components-ui"
import { useState } from "react"

export const options = [
  { text:'', value:'', abbreviation:'' },
  { text:'Alabama', value:'Alabama', abbreviation:'AL' },
  { text:'Alaska', value:'Alaska', abbreviation:'AK' },
  { text:'American Samoa', value:'American Samoa', abbreviation:'AS', territory:true },
  { text:'Arizona', value:'Arizona', abbreviation:'AZ' },
  { text:'Arkansas', value:'Arkansas', abbreviation:'AR' },
  { text:'California', value:'California', abbreviation:'CA' },
  { text:'Colorado', value:'Colorado', abbreviation:'CO' },
  { text:'Connecticut', value:'Connecticut', abbreviation:'CT' },
  { text:'Delaware', value:'Delaware', abbreviation:'DE' },
  { text:'District of Columbia', value:'District of Columbia', abbreviation:'DC' },
  { text:'Florida', value:'Florida', abbreviation:'FL' },
  { text:'Georgia', value:'Georgia', abbreviation:'GA' },
  { text:'Guam', value:'Guam', abbreviation:'GU', territory:true },
  { text:'Hawaii', value:'Hawaii', abbreviation:'HI' },
  { text:'Idaho', value:'Idaho', abbreviation:'ID' },
  { text:'Illinois', value:'Illinois', abbreviation:'IL' },
  { text:'Indiana', value:'Indiana', abbreviation:'IN' },
  { text:'Iowa', value:'Iowa', abbreviation:'IA' },
  { text:'Kansas', value:'Kansas', abbreviation:'KS' },
  { text:'Kentucky', value:'Kentucky', abbreviation:'KY' },
  { text:'Louisiana', value:'Louisiana', abbreviation:'LA' },
  { text:'Maine', value:'Maine', abbreviation:'ME' },
  { text:'Marshall Islands', value:'Marshall Islands', abbreviation:'MH', territory:true },
  { text:'Maryland', value:'Maryland', abbreviation:'MD' },
  { text:'Massachusetts', value:'Massachusetts', abbreviation:'MA' },
  { text:'Michigan', value:'Michigan', abbreviation:'MI' },
  { text:'Micronesia', value:'Micronesia', abbreviation:'FM', territory:true },
  { text:'Minnesota', value:'Minnesota', abbreviation:'MN' },
  { text:'Mississippi', value:'Mississippi', abbreviation:'MS' },
  { text:'Missouri', value:'Missouri', abbreviation:'MO' },
  { text:'Montana', value:'Montana', abbreviation:'MT' },
  { text:'Nebraska', value:'Nebraska', abbreviation:'NE' },
  { text:'Nevada', value:'Nevada', abbreviation:'NV' },
  { text:'New Hampshire', value:'New Hampshire', abbreviation:'NH' },
  { text:'New Jersey', value:'New Jersey', abbreviation:'NJ' },
  { text:'New Mexico', value:'New Mexico', abbreviation:'NM' },
  { text:'New York', value:'New York', abbreviation:'NY' },
  { text:'North Carolina', value:'North Carolina', abbreviation:'NC' },
  { text:'North Dakota', value:'North Dakota', abbreviation:'ND' },
  { text:'Northern Marianas', value:'Northern Marianas', abbreviation:'MP', territory:true },
  { text:'Ohio', value:'Ohio', abbreviation:'OH' },
  { text:'Oklahoma', value:'Oklahoma', abbreviation:'OK' },
  { text:'Oregon', value:'Oregon', abbreviation:'OR' },
  { text:'Palau', value:'Palau', abbreviation:'PW', territory:true },
  { text:'Pennsylvania', value:'Pennsylvania', abbreviation:'PA' },
  { text:'Puerto Rico', value:'Puerto Rico', abbreviation:'PR', territory:true },
  { text:'Rhode Island', value:'Rhode Island', abbreviation:'RI' },
  { text:'South Carolina', value:'South Carolina', abbreviation:'SC' },
  { text:'South Dakota', value:'South Dakota', abbreviation:'SD' },
  { text:'Tennessee', value:'Tennessee', abbreviation:'TN' },
  { text:'Texas', value:'Texas', abbreviation:'TX' },
  { text:'Utah', value:'Utah', abbreviation:'UT' },
  { text:'Vermont', value:'Vermont', abbreviation:'VT' },
  { text:'Virgin Islands', value:'Virgin Islands', abbreviation:'VI', territory:true },
  { text:'Virginia', value:'Virginia', abbreviation:'VA' },
  { text:'Washington', value:'Washington', abbreviation:'WA' },
  { text:'West Virginia', value:'West Virginia', abbreviation:'WV' },
  { text:'Wisconsin', value:'Wisconsin', abbreviation:'WI' },
  { text:'Wyoming', value:'Wyoming', abbreviation:'WY' },
]

/**
 * A FormField of searchable US states.
 * 
 * @example
  // FormField values can overriden, for example to send state abbreviations as values:
  
  import { options, FormFieldUsStates } from './FormFieldUsStates';
  export default () => <FormFieldUsStates options={ options.filter(o => !o.territory).map(o => ({ text: o.text, value: o.abbreviation })) } />
 */
export default function FormFieldUsStates(props) {
  const [filteredOptions, setFilteredOptions] = useState(options.filter(o => !o.territory))

  const onSearch = (val) => {
    const results = options.filter(o => !o.territory && o.text.toLowerCase().includes(val.toLowerCase()))
    setFilteredOptions(results)
  }

  return (
    <FormField
      type='search'
      options={filteredOptions}
      onSearch={onSearch}
      { ...props }
    />
  )
}